import React, {Component} from 'react';
import {ErrorMessage, Field, Form, Formik} from "formik";
import {Redirect} from "react-router";
import Loading from "./Parts/Loading";
import {withTranslation} from "react-i18next";
import * as qs from "query-string";
import {toast} from "react-toastify";
import ContactsForm from "./Parts/ContactsForm";

class CreateApplication extends Component {
    constructor(props) {
        super(props);

        let suggestion = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
        suggestion.type = suggestion.product;

        this.state = {
            token: null,
            suggestion: suggestion,
            knows_about_future_financial_changes: false
        };

        this.formSubmit = this.formSubmit.bind(this)
    }

    formSubmit(values, actions) {
        let payload = {...values, ...this.state.suggestion};
        payload.knows_about_future_financial_changes = this.state.knows_about_future_financial_changes;

        //new version
        gtm.sendEvent('base', {
            event: 'lead_collection.continued',
            products: {
                loan_amount: this.state.suggestion.amount,
                loan_period: this.state.suggestion.term,
                product_code: this.state.suggestion.type,
            }
        }, 2);

        axios.post('/api/process/create_application', payload)
            .then(data => {
                    actions.setSubmitting(false);
                    if (data.data.status === 'success') {
                        this.setState({token: data.data.data.token});
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                })
    }

    handleFFChange = event => {
        this.setState({knows_about_future_financial_changes: event.target.value});
    };

    render() {
        if (this.state.token !== null) {
            return (
                <Redirect push={true} to={'/' + this.state.token + '/process/consent'}/>
            )
        }

        return <ContactsForm
            suggestion={this.state.suggestion}
            data={{
                first_name: '',
                last_name: '',
                personal_code: '',
                incomes: '',
                email: '',
                phone: '',
                bonus_code: '',
                amount_cl: '',
                amount_mortgage: '',
                amount_other: '',
                knows_about_future_financial_changes: false,
            }}
            loading={false}
            submitFunction={this.formSubmit}
            handleFFChange={this.handleFFChange}
        />
    }
}

export default withTranslation()(CreateApplication);
